import { render, staticRenderFns } from "./re-content-placeholder.vue?vue&type=template&id=788b7d37&lang=pug"
import script from "./re-content-placeholder.vue?vue&type=script&lang=js"
export * from "./re-content-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports